import { Text, Stack, Spinner, VStack, Divider } from "@chakra-ui/react";
import { KYDEventMetrics } from "@common/interfaces/KYDEvent";

import {
  BarChart,
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

export const TicketSalesChart = (props: {
  data: KYDEventMetrics;
  isLoading: boolean;
}) => {
  function CustomTooltip({ payload, label, active }) {
    if (active) {
      return (
        <Stack
          p={3}
          spacing={1}
          borderColor={"gray.300"}
          borderWidth={"1px"}
          rounded={"md"}
          bg="white"
        >
          <Text fontSize={"xs"} fontWeight={"bold"}>
            {label}
          </Text>
          <Text fontSize={"xs"}>{payload[0]?.payload.gmv_display}</Text>
          <Text fontSize={"xs"}>
            {payload[0]?.payload.tickets_purchased === 1
              ? `${payload[0]?.payload.tickets_purchased} ticket`
              : `${payload[0]?.payload.tickets_purchased} tickets`}
          </Text>
          <Divider />
          <Stack spacing={1}>
            {props.data.bars
              ?.map((bar) => {
                const pl = payload[0]?.payload;
                if (bar) {
                  for (const key of Object.keys(pl || {})) {
                    if (key === bar.key) {
                      return (
                        <Text
                          key={key}
                          color={bar.color}
                          fontSize={"sm"}
                        >{`${bar.name}: ${payload[0]?.payload[key]}`}</Text>
                      );
                    }
                  }
                }

                return null;
              })
              .reverse()}
          </Stack>
        </Stack>
      );
    }

    return null;
  }

  if (props.isLoading) {
    return (
      <VStack w="100%">
        <Spinner />
        <Text>Loading ticket sales...</Text>
      </VStack>
    );
  }

  if (!props.data) {
    return null;
  }

  return (
    <Stack
      rounded={"lg"}
      width={"100%"}
      height={props.data?.metrics?.length > 0 ? "400px" : "85px"}
    >
      <Text w="100%" textAlign="left" color="black" fontWeight="bold">
        Ticket Sales
      </Text>
      {props.data?.metrics?.length > 0 ? (
        <ResponsiveContainer>
          <BarChart data={props.data.metrics}>
            <Tooltip
              cursor={{ fill: "#eee" }}
              labelStyle={{ color: "black" }}
              //@ts-ignore
              content={<CustomTooltip />}
            />
            {props.data.bars && props.data.bars.length > 0 ? (
              props.data.bars.map((bar) => (
                <Bar
                  key={bar.key}
                  name={bar.name}
                  type="monotone"
                  dataKey={bar.key}
                  fill={bar.color}
                  stackId="a"
                  maxBarSize={10}
                />
              ))
            ) : (
              <Bar
                name="Tickets"
                type="monotone"
                dataKey="tickets_purchased"
                fill="#000"
                maxBarSize={10}
              />
            )}
            <XAxis dataKey="date" interval="preserveStartEnd" />
            <YAxis  allowDecimals={false} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Text color="gray.500">No ticket sales data to display yet</Text>
      )}
    </Stack>
  );
};
